import Vuex from "vuex";

const state = {
  gameList: []
}

const actions = {

}

const mutations = {
  setGameList(state, param) {
    state.gameList = [].concat(param)
    // console.log('state.gameList.....', state.gameList)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/os.js